import { render, staticRenderFns } from "./CourseDescription.vue?vue&type=template&id=20728d6c&scoped=true&"
import script from "./CourseDescription.vue?vue&type=script&lang=js&"
export * from "./CourseDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20728d6c",
  null
  
)

export default component.exports